import React from "react";
import Tooltip from "@mui/material/Tooltip";
import LayersIcon from "@mui/icons-material/Layers";

function FilteredDepartmentShiftCard({
  shifts,
  roleNames,
  getTime,
  daily,
  compact,
  besideOtherStoreMarker,
  onLightCard,
  minimizeMode,
}) {
  const shift = shifts?.[0];
  if (!shift) return null;

  const roleName = roleNames?.find(
    (role) => role.id === shift.role_id
  )?.role_name;
  const extraShiftCount = Math.max((shifts?.length || 1) - 1, 0);

  if (compact) {
    // A hoverable icon, the same on every card, rather than a label that
    // would cover the card's own text. Sits bottom-right, left of the
    // other-store icon and the warning icon. Dark on the light time-off,
    // unavailable and other-store cards, white on a coloured shift card. Its
    // offsets follow the warning icon's, which sits lower in minimize mode.
    return (
      <div
        className={`absolute z-20 ${
          minimizeMode
            ? `bottom-0 ${besideOtherStoreMarker ? "right-7" : "right-4"}`
            : `bottom-1 ${besideOtherStoreMarker ? "right-8" : "right-5"}`
        }`}
      >
        <Tooltip
          title={
            <div>
              <p>Also scheduled in a department outside the current filter</p>
              <ul className="list-disc pl-4">
                {shifts.map((outsideShift, i) => (
                  <li key={i}>
                    {outsideShift.times_unknown
                      ? ""
                      : `${getTime(outsideShift.shift_start)} - ${getTime(
                          outsideShift.shift_end
                        )} · `}
                    {roleNames?.find((role) => role.id === outsideShift.role_id)
                      ?.role_name ||
                      outsideShift.role_type ||
                      "Other department"}
                  </li>
                ))}
              </ul>
            </div>
          }
        >
          <LayersIcon
            sx={{ fontSize: "10px" }}
            className={onLightCard ? "text-slate-500" : "text-white"}
          />
        </Tooltip>
      </div>
    );
  }

  return (
    <div
      className={`bg-slate-200 text-slate-500 rounded-lg border border-slate-300 px-3 flex flex-col justify-center overflow-hidden ${
        daily ? "h-10 w-[85%]" : "h-full w-full"
      }`}
      title="Scheduled in a department outside the current filter"
    >
      <p className="text-xs font-medium truncate">
        {shift.times_unknown
          ? ""
          : `${getTime(shift.shift_start)} - ${getTime(shift.shift_end)}`}
      </p>
      <p className="text-xxs truncate">
        {roleName || shift.role_type || "Other department"}
        {extraShiftCount > 0
          ? ` +${extraShiftCount} more`
          : ""} · Outside filter
      </p>
    </div>
  );
}

export default FilteredDepartmentShiftCard;
